<template>
    <div class="d-flex flex-column ml-3" style="width: 17rem">
        <div style="font-size: 0.85rem">
            <span class="text-muted" style="font-weight: 600">{{ element.packageName }}</span>
            <span style="margin-left: 0.5rem">({{ element.numberCard }} GPU
                {{ element.detailGraphic }})</span>
        </div>
        <div v-if="element.enabledWindows" class="
                d-flex
                flex-row
                align-items-center
                justify-content-between
                mt-1
            ">
            <div class="d-flex flex-row align-items-center">
                <img src="/os/1.svg" style="height: 0.9rem" alt="" />
                <div class="text-muted" style="margin-left: 0.5rem">Windows 10</div>
            </div>
            <div :style="`font-weight: 500; color: ${progressColor(
                    100 -
                        (element.percentWindows === 100
                            ? 95
                            : element.percentWindows)
                )}`">
                {{ element.percentWindows === 0 ? "Full" : "Available" }}
            </div>
        </div>
        <div v-if="element.enabledUbuntu" class="
                d-flex
                flex-row
                align-items-center
                justify-content-between
                mt-1
            ">
            <div class="d-flex flex-row align-items-center">
                <img src="/os/2.svg" style="height: 0.9rem" alt="" />
                <div class="text-muted" style="margin-left: 0.5rem">Linux (Ubuntu)</div>
            </div>
            <div :style="`font-weight: 500; color: ${progressColor(
                    100 -
                        (element.percentUbuntu === 100
                            ? 95
                            : element.percentUbuntu)
                )}`">
                {{ element.percentUbuntu === 0 ? "Full" : "Available" }}
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.package-server-state-label{
    font-weight: 500;
    color: #fff;
    line-height: 1.2rem;
    padding-bottom: 2px;
    border-radius: 50px;
}
</style>
<script>
export default {
    data() {
        return {
            toolTipDict: {
                1: "Can boot. The number of servers is at a perfect level",
                2: "Can boot. The number of servers is at a stable level",
                3: "Please boot quickly. The number of servers is scarce",
                4: "Server is full. Please come back later",
            },
            imgDict: {
                1: "dot-green",
                2: "dot-blue",
                3: "dot-orange",
                4: "dot-red",
            },
            colorDict: {
                1: "#4CAF50",
                2: "#2196F3",
                3: "#E65100",
                4: "#F44336",
            },
        };
    },

    props: {
        element: {
            type: Object,
            default: null,
        },
    },

    methods: {
        format(percentage) {
            return percentage === 100 ? "Full" : `${percentage}%`;
        },

        progressColor(percent) {
            if (percent === 100) {
                return "#EF5350";
            } else {
                return "#19b5fe";
            }
        },

        // progressColor(percent) {
        //     if (percent === 100) {
        //         return "#EF5350";
        //     } else if (percent > 66) {
        //         return "#FFA726";
        //     } else if (percent > 33) {
        //         return "#42A5F5";
        //     } else {
        //         return "#66BB6A";
        //     }
        // },
    },
};
</script>